import { format, isValid } from "date-fns";

export function formatEncounterDateTime(start?: string | null) {
  if (!start) return "-";
  const date = new Date(start);
  return isValid(date) ? format(date, "dd MMM yyyy, hh:mm a") : "-";
}
